import React from "react";

export const WelcomeContainer = () => {
  return <div />;
};
